import React from 'react';
import _get from 'lodash/get';
import classNames from 'classnames';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { useTranslation } from 'react-i18next';
import { SelectPanelOptionRendererProps } from '../types';
import { getOptionLabel } from '../utils';
import styles from '../SelectPanel.module.scss';

export function AreaOption({
  option,
  isSelected,
  isMulti,
}: SelectPanelOptionRendererProps): React.ReactElement {
  const { t } = useTranslation();
  const { data } = option || {};
  const isPoorWifi = _get(data, 'poorWifi');

  // Returns a Fragment (checkbox + content) so both slot directly into the
  // SelectPanel option button's own grid — wrapping them in a single element
  // collapses the label into the button's min-content column.
  return (
    <>
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.entityOptionLabelWrap}>
        <span
          className={classNames(styles.entityOptionLabel, {
            [styles.optionLabelWithOfflineIcon]: isPoorWifi,
          })}
        >
          {getOptionLabel(option, t)}
          {isPoorWifi && (
            <span className={styles.offlineIcon}>
              <MaterialIcon icon="wifi_off" size="md-16" />
            </span>
          )}
        </span>
      </span>
    </>
  );
}
